module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_quests_big.785facf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_quests_big.jpg
// module id = 3039
// module chunks = 11